import { Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Router  } from '@angular/router';
import { GAHAppResponse } from '@data/schema/gah-app-response';
import { ReleaseInfo } from '@data/schema/release-info';
import { User } from '@data/schema/user-state';
import { AuthenticationService } from '@gah-core/services/authentication.service';
import { UserStoreService } from '@gah-core/services/user-store.service';
import { ManageHomepageService } from '@modules/admin/manage-homepage/services/manage-homepage.service';
import { GoogleanalyticsmoduleserviceService } from '@shared/services/googleanalyticsmoduleservice.service';
import { DynamicBreadcrumbService } from '@shared/services/dynamic-breadcrumb.service';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { SwiperOptions } from 'swiper/types';
import { HomeFeaturedTitles } from '../models/home-featured-titles.model';
import { HomeTitles } from '../models/home-titles.model';
import { HomeService } from '../services/home.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SwiperContainer } from 'swiper/element';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  // @ViewChild('singleItemSwiper') singleItemSwiper?: ElementRef<SwiperContainer>;
  singleItemSwiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    centerInsufficientSlides: false,
    speed: 1000,
    loop: true,
    navigation: true,
    pagination: { clickable: true },
    autoplay: {
      delay: 10000,
      disableOnInteraction: false
    }
  };
  multipleItemSwiperConfig: SwiperOptions = {
    spaceBetween: 10,
    centerInsufficientSlides: false,
    slidesPerView: 1,
    navigation: true,
    pagination: { clickable: true },
    breakpoints: {
      640: { slidesPerView: 2, spaceBetween: 20 },
      768: { slidesPerView: 3, spaceBetween: 20 },
      992: { slidesPerView: 4, spaceBetween: 20 },
      1200: { slidesPerView: 5, spaceBetween: 20 },
      1440: { slidesPerView: 6, spaceBetween: 20 },
      1600: { slidesPerView: 7, spaceBetween: 20 }
    }
  };
  territoryId: number = null;
  territoryName: string = 'Home';
  groupTypeCode: string = null;
  assetIds: Array<number> = [10610106];
  onReleaseTitles: HomeTitles[] = [];
  upcomingTitles: HomeTitles[] = [];
  recentUploadedAssetsTitles: HomeTitles[] = [];
  featuredTitles: HomeFeaturedTitles[] = [];
  releaseInfo: ReleaseInfo[] = [];
  releaseInfoUpcoming: ReleaseInfo[] = [];
  fetchedHomePageTitles: boolean = false;
  navigationSubscription: Subscription;
  showNoResults: boolean = false;
  showFT: boolean = true;
  showRT: boolean = true;
  showUT: boolean = true;
  showNAT: boolean = true;
  counter: number = 5;
  groupTerritoryId: number;

  templateArray = [];
  sanitizedHTML: SafeHtml;
  sampleHTML: SafeHtml;
  footerComp;
  homePageAssets = null;
  assetsArray = [];
  private configLoaded = false;
  private fetchedNewAssets = false;

  nowPlayingArray = {
    id: 1,
    ifVariable: 'onReleaseTitles',
    elseVariable: 'loadingReleaseTitles',
    templateName: '#loadingReleaseTitles',
    labelName: 'on-release-label',
    forVariable: 'onReleaseTitles',
    code: 'NWPLY',
    sortOrder: 3,
    showField: true
  }
  newAssetsArray = {
    id: 2,
    ifVariable: 'recentUploadedAssetsTitles',
    elseVariable: 'loadingRecentUploadedAssetsTitles',
    templateName: '#loadingRecentUploadedAssetsTitles',
    labelName: 'new-assets-label',
    forVariable: 'recentUploadedAssetsTitles',
    code: 'NWAST',
    sortOrder: 2,
    showField: true
  }
  onComingArray = {
    id: 3,
    ifVariable: 'upcomingTitles',
    elseVariable: 'loadingUpcomingTitles',
    templateName: '#loadingUpcomingTitles',
    labelName: 'upcoming-label',
    forVariable: 'upcomingTitles',
    code: 'CMGSN',
    sortOrder: 1,
    showField: true
  }

  defaultArray = [this.onComingArray, this.newAssetsArray, this.nowPlayingArray];
  
  constructor(
    private homeService: HomeService,
    private log: NGXLogger,
    private userStoreService: UserStoreService,
    private router: Router,
    private dynamicBreadcrumbService: DynamicBreadcrumbService,
    public authService: AuthenticationService,
    private homepageService: ManageHomepageService,
    private googleanalyticsmoduleserviceService: GoogleanalyticsmoduleserviceService,
    private sanitizer: DomSanitizer,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.homepageService.fetchHomePageOrderData().subscribe((res: any) => {
      this.homepageService.fetchHomePageAssetsOrderData(this.userStoreService.userState.groupsTerritoryId).subscribe((res: any) => {
        this.homePageAssets = res.serviceResult;
        if(res.serviceResult.length > 0){
          for(let i=0; i< this.homePageAssets.length; i++){
            if(this.homePageAssets[i].homePageDataCode == 'NWAST'){
              this.newAssetsArray.sortOrder = this.homePageAssets[i].sortOrder; //i+1;
              this.newAssetsArray.code = this.homePageAssets[i].homePageDataCode;
              this.newAssetsArray.showField = this.homePageAssets[i].showAssetList;
              if(this.homePageAssets[i].showAssetList == true){
                this.assetsArray.push(this.newAssetsArray);
              }
            }else if(this.homePageAssets[i].homePageDataCode == 'NWPLY'){
              this.nowPlayingArray.sortOrder = this.homePageAssets[i].sortOrder;
              this.nowPlayingArray.code = this.homePageAssets[i].homePageDataCode;
              this.nowPlayingArray.showField = this.homePageAssets[i].showAssetList;
              if(this.homePageAssets[i].showAssetList == true){
                this.assetsArray.push(this.nowPlayingArray);
              }
            }else if(this.homePageAssets[i].homePageDataCode == 'CMGSN'){
              this.onComingArray.sortOrder = this.homePageAssets[i].sortOrder;
              this.onComingArray.code = this.homePageAssets[i].homePageDataCode;
              this.onComingArray.showField = this.homePageAssets[i].showAssetList;
              if(this.homePageAssets[i].showAssetList == true){
                this.assetsArray.push(this.onComingArray);
              }
            }
          }
          this.assetsArray.sort((a, b) => a.sortOrder - b.sortOrder);
        }else{
          this.assetsArray = this.defaultArray;
        }
        this.configLoaded = true;
        this.fetchNewAssetsIfNeeded();
      });
    });

    if (this.userStoreService.userState.isLegalAccepted) {
      this.fetchReleaseSchedule();
      this.authService.getCartItems();
    }
    let intervalId = setInterval(() => {
      this.counter = this.counter - 1;
      if (this.counter === 0) {
        this.showFT = this.showUT = this.showRT = this.showNAT = false;
        clearInterval(intervalId);
      }
    }, 1000);
    // * Added to update the breadcrumb data on every route change
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
     this.updateBreadcrumbs();
      
    });
    // * Implemented this way to not make home page items request if user state is not updated yet.
    this.userStoreService.userState$.subscribe((userState: User) => {
      if (!userState?.selectedTerritory?.territoryId) return;
      this.territoryName = userState?.selectedTerritory?.territoryName;
      this.territoryId = userState?.selectedTerritory?.territoryId;
      this.groupTerritoryId = userState?.groupsTerritoryId;
      this.groupTypeCode = userState?.selectedTerritory?.groupTypeCode;
      this.updateBreadcrumbs();
      if (!this.fetchedHomePageTitles) {
        this.homeService
          .fetchHomePageReleaseData(this.territoryId, this.groupTypeCode)
          .pipe(first())
          .subscribe({
            next: (res: GAHAppResponse) => {
              this.showRT = this.showUT = false;
              this.showNoResults = true;
              this.onReleaseTitles = res?.serviceResult?.past;
              this.upcomingTitles = res?.serviceResult?.upcoming;
              this.fetchedHomePageTitles = true;
            },
            error: (err) => {
              this.showRT = this.showUT = false;
            },
          });

        // Fetch New Assets only after config is loaded to know if NWAST is visible
        this.fetchNewAssetsIfNeeded();

        this.homeService
          .fetchHomePageHeaderMediaData(this.userStoreService.userState.groupsTerritoryId)
          .pipe(first())
          .subscribe({
            next: (res: GAHAppResponse) => {
              this.showFT = false;
              this.showNoResults = true;
              let unsortedFeaturedTitles: HomeFeaturedTitles[] = res?.serviceResult;
              this.featuredTitles = unsortedFeaturedTitles?.sort((a, b) => {
                return a.displayOrder.valueOf() - b.displayOrder.valueOf();
              });
              this.fetchedHomePageTitles = true;
            },
            error: (err) => {
              this.showFT = false;
            },
          });
      }
    });
  }

  updateBreadcrumbs(): void {
    
    this.dynamicBreadcrumbService.updateBreadcrumbLabels({
      territoryName: this.territoryName,
    });
    this.dynamicBreadcrumbService.updateBreadcrumbs([
      {
        label: this.territoryName,
        url: '/'
      }
    ]);
  }
  getLabel(index){
    let label = '';
    index == 1 ? label = this.translate.instant('on-release-label') : index == 2 ? label = this.translate.instant('new-assets-label') : label = this.translate.instant('upcoming-label');
    return label;
  }

  getForLoopValue(i){
    let assets = null;
    i == 1 ? assets = this.onReleaseTitles : i == 2 ? assets = this.recentUploadedAssetsTitles : assets = this.upcomingTitles;
    return assets;
  }

  /**
   * This method handles swiper slide change event.
   * This method resets video progress for active slide and pauses
   * the auto slide transition untill video finishes playing
   *
   * @param event - Swiper slide change event contains details of swiper instance
   */
  swiperSlideChanged(event: CustomEvent) {
    console.log('Swiper slide changed', event);
    const [_swiper] = event.detail;
    const swiperInstance = _swiper[0];    
    if (!swiperInstance) return;
    let activeIndex = swiperInstance.activeIndex;
    if (this.featuredTitles[activeIndex - 1]?.type === 'video') {

      let video: HTMLVideoElement =
        swiperInstance.slides[activeIndex].querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.addEventListener('ended', () => {
          swiperInstance.autoplay.start();
          setTimeout(() => {
            swiperInstance.slideNext();
          }, 1000);
        });
        swiperInstance.autoplay.stop();
        video.play();
      }
    } else {
      swiperInstance.autoplay.start();
    }
  }

  /**
   * Fetch New Assets data only if config has loaded and NWAST section is visible.
   * Called from both the config callback and the userState$ subscription —
   * will only execute the API call once both conditions are met.
   */
  private fetchNewAssetsIfNeeded(): void {
    if (!this.configLoaded || !this.groupTerritoryId || this.fetchedNewAssets) return;

    if (this.newAssetsArray?.showField === false) {
      this.showNAT = false;
      return;
    }

    this.fetchedNewAssets = true;
    this.homeService
      .fetchTitlesForRecentPublished(this.groupTerritoryId)
      .pipe(first())
      .subscribe({
        next: (res: GAHAppResponse) => {
          this.showNAT = false;
          this.showNoResults = true;
          this.recentUploadedAssetsTitles = res?.serviceResult;
        },
        error: (err) => {
          this.showNAT = false;
        },
      });
  }

  /**
   * Function - Fetch Release Schedule
   */
  fetchReleaseSchedule() {
    if (
      this.authService.userState != null &&
      this.authService.userState.groupsTerritoryId != null &&
      this.authService.userState.username != null
    ) {
      this.homepageService
        .fetchUserGuide(
          this.authService.userState.groupsTerritoryId,
          this.authService.userState.username,
          'RS'
        )
        .subscribe();
    }
  }

  trackByFeatured(index: number, title: HomeFeaturedTitles) {
    return title.runnerId;
  }

  trackByUpcoming(index: number, title: HomeTitles) {
    return title.releaseId;
  }

  trackByOnRelease(index: number, title: HomeTitles) {
    return title.releaseId;
  }

  titleClick(event: any, title: HomeTitles) {
    this.router.navigateByUrl('/assets/' + title.titleId);
  }

  ngOnDestroy(): void {
    this.navigationSubscription?.unsubscribe();
  }
}